<template>
    <div>
        <div>
            <Head>
                <title>Mpesa B2C Settings</title>
            </Head>
            <h1 class="mb-8 text-3xl font-bold">Mpesa B2C Setting</h1>
        </div>
        <div v-if="setting"
             class="block max-w-lg p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                {{ setting.title }}
            </h5>
            <p class="font-normal text-gray-700 dark:text-gray-400 mb-5">
                {{ setting.description }}
            </p>
            <span>
                <strong class="text-white">Last updated: </strong>
                <small class="text-white">{{ setting.readable_updated_at }}</small>
            </span>
            <br/><br/>
            <span>
                <strong class="text-white">Password expires on: </strong>
                <small class="text-white">{{ setting.send_reminder_at }}</small>
            </span>
            <br/><br/>
            <span>
                <strong class="text-white">Remaining days: </strong>
                <small class="text-white">{{ setting.remaining_days }}</small>
            </span>
        </div>
        <form autocomplete="off" @submit.prevent="generateCredential"
              class="max-w-lg p-6 mt-4 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
            <input autocomplete="false" name="hidden" type="text" style="display:none;">
            <div class="mb-5">
                <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Enter Initiator Password
                </label>
                <input v-model="password" :type="passwordInputType" autocomplete="false"
                       class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                       required>
            </div>
            <div class="mb-2">
                <label class="relative inline-flex items-center mb-5 cursor-pointer">
                    <input v-model="showPassword" type="checkbox" class="sr-only peer">
                    <div
                        class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:w-5 after:h-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                    <span class="ms-3 ml-1 text-sm font-medium text-gray-900 dark:text-gray-300">
                       Show Password
                    </span>
                </label>
            </div>
            <div v-if="credential" class="mb-5">
                <label for="message" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    Your Security Credential
                </label>
                <textarea :value="credential" readonly rows="6"
                          class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                ></textarea>
            </div>
            <button type="submit"
                    class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                Generate
            </button>
        </form>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    layout: Layout,
    props: {
        setting: Object,
        credential: String
    },
    data: () => ({
        showPassword: false,
        password: "",

    }),
    computed: {
        passwordInputType() {
            return this.showPassword ? "text" : "password";
        }
    },
    mounted() {
        this.password = this.setting.meta_value
        console.log(this.password)
    },
    methods: {
        generateCredential() {
            this.$inertia.post('/settings/generate-mpesa-credentials', {
                password: this.password
            }, {
                preserveState: true
            })
        }
    }
}
</script>
